import classnames from "classnames";

export const AgentBadge = ({ agentName }: { agentName?: string }) => {
    const isBot = !agentName || agentName.trim() === '';
    const displayName = isBot ? 'Bot' : agentName;

    return (
        <span
            className={classnames(
                "badge rounded-pill d-inline-flex align-items-center px-2 py-1 shadow-sm fw-medium border",
                {
                    "bg-info": isBot,
                    "bg-danger": !isBot
                }
            )}
            style={{ fontSize: '0.7rem', maxWidth: '150px' }}
            title={displayName}
        >
            <i className={classnames("me-1", {
                "ri-robot-line": isBot,
                "ri-user-smile-line": !isBot
            })}></i>
            <span className="text-truncate">{displayName}</span>
        </span>
    );
};
